import {FC} from 'react';
import {Box, Typography} from '@mui/material';
import Button from '@components/Button';
import {IMAGE_TABLE_ALT, H5} from '@/utils/constants';
import lockIcon from '@icons/successfully.svg';
import {changePasswordModal} from './changePasswordModal.style';

interface ConfirmationModalProps {
	onCloseModal: () => void;
}

const ChangePasswordModalStep3: FC<ConfirmationModalProps> = ({onCloseModal}) => {
	return (
		<Box sx={changePasswordModal.content}>
			<Box sx={changePasswordModal.iconWrap}>
				<img src={lockIcon} alt={IMAGE_TABLE_ALT} />
			</Box>
			<Box sx={changePasswordModal.contentWrap}>
				<Typography variant={H5} sx={changePasswordModal.title}>
					Password Successfully Changed
				</Typography>
				<Typography sx={changePasswordModal.description}>Please use your new password to log in.</Typography>
			</Box>

			<Box sx={changePasswordModal.btnWrap}>
				<Button sx={changePasswordModal.btn} onClick={onCloseModal} title="Done" disableRipple />
			</Box>
		</Box>
	);
};

export default ChangePasswordModalStep3;
